export const SLOT_STORAGE_KEY = "selectedSlotTimeId";

export const sessionStorageHelper = {
  getKey<T>(key: string): T | null {
    try {
      if (!globalThis.sessionStorage) return null;
      const value = globalThis.sessionStorage.getItem(key);
      if (!value) return null;
      return JSON.parse(value) as T;
    } catch {
      return null;
    }
  },
  removeKey(key: string) {
    try {
      if (!globalThis.sessionStorage) return;
      globalThis.sessionStorage.removeItem(key);
    } catch {
      // Storage can be unavailable in restricted browser contexts.
    }
  },
};
